import { render } from "./VictoryPoints.vue?vue&type=template&id=93b936a2"
import script from "./VictoryPoints.vue?vue&type=script&lang=js"
export * from "./VictoryPoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/kingdoms/VictoryPoints.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93b936a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93b936a2', __exports__)) {
    api.reload('93b936a2', __exports__)
  }
  
  module.hot.accept("./VictoryPoints.vue?vue&type=template&id=93b936a2", () => {
    api.rerender('93b936a2', render)
  })

}


export default __exports__